import { useLocalization } from '@lib/localization';
import { type Inspection } from '@lib/spproject/types';
import { Paper, Typography } from '@mui/material';
import { PieChart } from '@mui/x-charts/PieChart';
import useNoticeColors from '@store/hooks/useNoticeColors';

interface InspectionStatusChartProps {
  data: Record<Inspection.NoticeType, number>;
}

const InspectionStatusChart: React.FC<InspectionStatusChartProps> = ({ data }) => {
  const { t } = useLocalization();
  const noticeColors = useNoticeColors();

  const chartData = [
    { id: 0, value: data.Ok, label: t('Common_Successful'), color: noticeColors.Ok },
    { id: 1, value: data.Warning, label: t('Common_Warning'), color: noticeColors.Warning },
    { id: 2, value: data.Error, label: t('Common_Error'), color: noticeColors.Error },
    { id: 3, value: data.NotChecked, label: t('Common_NotChecked'), color: noticeColors.NotChecked },
  ];

  const hasData = data && Object.values(data).some((value) => value > 0);

  return (
    <Paper
      sx={{
        p: 3,
        height: 400,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {hasData ? <PieChart
        series={[
          {
            data: chartData,
            innerRadius: 50,
            outerRadius: 100,
            paddingAngle: 2,
            cornerRadius: 8,
          },
        ]}
        height={300}
        margin={{ left: 0, right: 0, top: -20, bottom: 0 }}
        slotProps={{
          legend: {
            direction: 'horizontal',
            position: { vertical: 'bottom', horizontal: 'center' },
            sx: {
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              justifyItems: 'start',
            },
          },
        }}
      /> :
        <Typography sx={{ fontSize: '0.875rem' }}>
          {t('Project_Overview_NoData')}
        </Typography>
      }
    </Paper>
  );
};

export default InspectionStatusChart;
